<template>
    <div>
        <LoaderFullscreen />
    </div>
</template>

<script>
    import { LoaderFullscreen } from '@tech_hexeko/design-system'

    export default {
        components: {
            LoaderFullscreen
        },
        created() {
            this.$store.dispatch('auth/logout').then(() => {
                this.$router.push({ name: 'login' }).catch(() => {});
            })
        }
    }
</script>